import React from 'react';
import { Descriptions } from 'antd';
import { DescriptionsProps as DescriptionsCopyProps } from 'antd/lib/descriptions';

export type DescriptionsProps = DescriptionsCopyProps;

const ProDescriptions: React.FC<DescriptionsProps> = (props) => {
  const { children, ...resProps } = props;

  return <Descriptions {...resProps}>{children}</Descriptions>;
};

export default ProDescriptions;
